import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useSnackbar } from 'ui-components';
import { apiClientV2 } from '~/api/client';
import { mapCreatorFromApiModelToViewModel } from '~/clientApi';
import { queryClient } from '~/config/reactQueryConfig';
import { ALL_SOCIAL_PLATFORM_TYPE } from '~/constants';
import {
  AGENCIES_COLLECTION_QUERY_KEY,
  AGENCY_TOKEN,
  CREATOR_PROFILE_QUERY_KEY,
  SAVED_LIST_CREATORS,
  TR_CREATORS_LIST_QUERY_KEY,
} from '~/queries/keys';
import { ICreator } from '~/types';

type Payload = {
  id: string;
  platform: ALL_SOCIAL_PLATFORM_TYPE;
};

export const useRemovePlatform = () => {
  const snackbar = useSnackbar();

  return useMutation<ICreator, AxiosError, Payload, Response>(
    ({ id, ...payload }: Payload) => {
      return apiClientV2
        .put(`/creators/${id}/disconnect-platform`, payload)
        .then((r) => mapCreatorFromApiModelToViewModel(r.data));
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [CREATOR_PROFILE_QUERY_KEY],
        });
        queryClient.invalidateQueries({
          queryKey: [AGENCIES_COLLECTION_QUERY_KEY],
        });
        queryClient.invalidateQueries({
          queryKey: [TR_CREATORS_LIST_QUERY_KEY],
        });
        queryClient.invalidateQueries({
          queryKey: [SAVED_LIST_CREATORS],
        });
        queryClient.invalidateQueries([AGENCY_TOKEN]);
      },
      onError: () => {
        snackbar.error({
          description: '“An error occurred while deleting the creator',
        });
      },
    },
  );
};
